const encodeUriAll = (value) => {
  return value.replace(
    /[^A-Za-z0-9]/g,
    (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`
  );
};

export default encodeUriAll;
